<script>
    import { onMount } from 'svelte';
    import { firestore, storage } from "../../firebase/firebase.js";
    import { navigateTo } from "svelte-router-spa";
    import CardsList from "../../components/CardsList.svelte"
    import { user, userProfile } from "../../store/auth.js";

    export let currentRoute;
    export let params;

    var language = '';
    var country = '';
    var deckId = '';
    var viewedDeck;
    var deckImage;
    var description = '';
    var title = '';
    var isFeatured = false;
    var isAvailable = false;
    var cards = '';
    var cardsLength = 0;
    var cardsDirection = 'ltr'
    var loading = false;
    var deleteLoading = false;
    var canFetch = false;

    $: {
        if ($userProfile)
            init();
    }

    function changeCardsDirection() {
        if (cardsDirection == 'ltr') {
            cardsDirection = 'rtl'
        } else {
            cardsDirection = 'ltr'
        }
    }

    async function init() {
        try {
            language = currentRoute.namedParams['lang'];
            country = currentRoute.namedParams['countryId'];
            deckId = currentRoute.namedParams['deck'];
            if ($userProfile) {
                if ($userProfile.role == 'admin') {
                    canFetch = true;
                } else {
                    if ($userProfile.role == 'manager' && $userProfile.countries && $userProfile.countries[currentRoute.namedParams['countryId']] && $userProfile.countries[currentRoute.namedParams['countryId']].includes(currentRoute.namedParams['lang'])) {
                        canFetch = true;
                    }
                }
            }
            if (canFetch) {
                if (deckId != 'new') {
                    loading = true;
                    await fetchDeck(deckId)
                    loading = false;
                }
            }
        } catch (error) {

        }
    }

    async function fetchDeck(deckId) {
        try {
            var temp = await firestore.collection('decks').doc(deckId).get();
            if (temp && temp.exists && temp.data()) {
                viewedDeck = temp
                var data = viewedDeck.data();
                title = data.title
                description = data.description
                isAvailable = data.is_available
                isFeatured = data.is_featured
                cards = data.cards || ''
                if (cards && cards.length > 0) {
                    var splitted = cards.split('\n');
                    cardsLength = splitted.length;
                }
                if (data.image) {
                    deckImage = { ...data.image }
                }
            }
        } catch (error) {
        }
    }

    async function createDeck() {
        try {
            if (!loading) {
                var result = validateDeck();
                if (result) {
                    loading = true;
                    uploadNewImage()
                        .then(async result => {
                            var temp = { ...result }
                            if (temp.file) delete temp.file;
                            var res = await firestore.collection('decks').add({
                                title: title,
                                description: description,
                                language: language,
                                country: country,
                                is_available: isAvailable,
                                is_featured: isFeatured,
                                is_premium: false,
                                image: temp,
                                cards: cards,
                                created_at: new Date()
                            })
                                .then(async result => {
                                    if (result && result.id) {
                                        deckId = result.id
                                        await fetchDeck(result.id)
                                        navigateTo("/admin/country/" + country + "/" + language + '/decks/' + result.id);
                                    }
                                })
                                .catch(error => {

                                })
                                .finally(() => {
                                    loading = false;
                                })
                        })
                        .catch(error => {
                            loading = false;
                        })
                }
            }
        } catch (error) {
            loading = false;
        }
    }

    function updateDeck() {
        try {
            if (!loading) {
                var result = validateDeck();
                if (result) {
                    loading = true;
                    uploadNewImage()
                        .then(async result => {
                            var temp = { ...result }
                            if (temp.file) delete temp.file;
                            var res = await firestore.collection('decks').doc(deckId).set({
                                title: title,
                                description: description,
                                is_available: isAvailable,
                                is_featured: isFeatured,
                                is_premium: false,
                                image: temp,
                                cards: cards
                            }, { merge: true })
                                .then(async result => {
                                    await fetchDeck(deckId)
                                })
                                .catch(error => {

                                })
                                .finally(() => {
                                    loading = false;
                                })
                        })
                        .catch(error => {
                            loading = false;
                        })
                }
            }
        } catch (error) {
            loading = false;
        }
    }

    async function deleteDeck() {
        if (!deleteLoading) {
            try {
                deleteLoading = true;
                await firestore.collection('decks').doc(deckId).delete();
                deleteLoading = false;
                navigateTo("/admin/lang/" + language + '/decks');
            } catch (error) {
                deleteLoading = false;
            }
        }
    }

    function validateDeck() {
        var isValid = true;
        try {
            if (!language || !deckImage) {
                isValid = false;
            }
            if (!title || title.length <= 0) {
                isValid = false;
            }
            if (!description && description.length <= 0) {
                isValid = false;
            }
        } catch (error) {
            isValid = false;
        }
        return isValid;
    }

    function openFilePicker() {
        try {
            var element = document.getElementById('deckImageInput')
            element.click();
        } catch (error) {
        }
    }

    async function uploadNewImage() {
        return new Promise(async (resolve, reject) => {
            try {
                if (deckImage && deckImage.isNew) {
                    if (deckImage.file && deckImage.id) {
                        var fileRef = storage.ref("/decks/" + language + "/" + deckImage.id);
                        var task = fileRef.put(deckImage.file);
                        if (task) {
                            task.on(
                                "state_changed",
                                function progress(snapshot) {
                                    var progress = Math.round(
                                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                                    );
                                },

                                function error(error) {
                                },

                                async function complete() {
                                    await task.ref_
                                        .getDownloadURL()
                                        .then(downloadedUrl => {
                                            resolve({
                                                ...deckImage,
                                                isNew: false,
                                                url: downloadedUrl
                                            });
                                        })
                                        .catch(e => { });
                                }
                            );
                        }
                    }
                } else {
                    resolve(deckImage);
                }
            } catch (error) {
                reject(error)
            }
        })
    }

    function loadDeckImage(event) {
        try {
            if (event && event.target && event.target.files) {
                if (event.target.files && event.target.files.length > 0) {
                    const pic = event.target.files[0];
                    deckImage = {
                        file: pic,
                        title: pic.name,
                        isNew: true,
                        url: '',
                        id: Date.now().toString() + '_' + '_' + pic.name,
                    }
                    setTimeout(() => {
                        try {
                            var image = document.getElementById(deckImage.id);
                            image.src = URL.createObjectURL(deckImage.file);
                        } catch (error) {

                        }
                    }, 100)
                    this.key = Date.now()
                }
            }
        } catch (error) {

        }
    }

    function setCardsLenth(e) {
        try {
            if (e && e.target && e.target.value) {
                var splitted = e.target.value.toString().split('\n');
                cardsLength = splitted.length;
            }
        } catch (error) {

        }

    }
</script>

{#if canFetch}
<div class:loading={loading} class:deleteLoading={deleteLoading} class="decks-container">
    <div class="header">
        {#if viewedDeck}
            <div>
                Deck Preview            
            </div>
                <div class="my_btn_group">
                    <div class="mr-1">
                        {#if deleteLoading}
                        <button class="btn btn-outline-danger btn-sm" type="button">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="sr-only">Loading...</span>
                        </button>
                    {:else}
                        <button on:click="{deleteDeck}" type="button" class="btn btn-outline-danger btn-sm">DELETE</button>
                    {/if}
                    </div>
                    <div>
                        {#if loading}
                <button class="btn btn-outline-primary btn-sm" type="button">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Loading...</span>
                </button>
            {:else}
                <button on:click="{updateDeck}" type="button" class="btn btn-outline-primary btn-sm">UPDATE</button>
            {/if}
                    </div>
                </div>
        {:else}
            <div>
                New Deck   
            </div>
            {#if loading}
                <button class="btn btn-outline-primary btn-sm" type="button">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Loading...</span>
                </button>
            {:else}
                <button on:click="{createDeck}" type="button" class="btn btn-outline-primary btn-sm">CREATE</button>
            {/if}
        {/if}
    </div>

    

    <form class="deck_form">
        <div class="row no-gutters" style="justify-content: space-between !important;">
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-2" style="padding: 0 10px;">
                <!-- image -->
                <div class="image_section" :key="key">
                    {#if !deckImage}
                        <div class="deck_image_input" on:click="{openFilePicker}">
                            Select Image
                        </div>
                    {:else}
                        <div class="image_wrapper">
                            <button  on:click="{openFilePicker}" type="button" class="btn btn-dark btn-sm override_image_btn">New</button>
                            {#if deckImage.isNew}
                                <img class="picked_image" id="{deckImage.id}" />
                            {:else}
                                <img class="picked_image" src="{deckImage['url']}" />
                            {/if}
                        </div>
                    {/if}
                </div>

                <!-- title & description -->
                <div class="deck_info">
                    <div class="row no-gutters mb-2">
                        <div class="col">
                            <input bind:value={title} type="text" class="form-control" id="deck_title" placeholder="Title" />
                        </div>
                    </div>
                    <div class="row no-gutters mb-2">
                        <div class="col">
                            <textarea bind:value={description} class="form-control" id="deck_descriptio" placeholder="Description" rows="3"></textarea>
                        </div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col">
                            <div class="custom-control custom-checkbox">
                                <input bind:checked={isAvailable} type="checkbox" class="custom-control-input" id="is_available">
                                <label class="custom-control-label" for="is_available">Is Available</label>
                            </div>                    
                        </div>
                    </div>
    
                    <div class="row no-gutters">
                        <div class="col">
                            <div class="custom-control custom-checkbox">
                                <input bind:checked={isFeatured} type="checkbox" class="custom-control-input" id="is_featured">
                                <label class="custom-control-label" for="is_featured">Is Featured</label>
                            </div>                    
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="padding: 0 10px;">
                <!-- cards -->
                <label class="d-flex jcsb aic w-100" for="deck_cards">
                    <div style="padding-top: 17px;" class="w-100">
                        <span>Cards</span>
                    </div>
                    <div>
                        <button on:click="{changeCardsDirection}" type="button" class="btn btn-light">{cardsDirection == 'ltr' ? 'rtl' : 'ltr'}</button>
                    </div>
                </label>
                <textarea class:ltr_cards={cardsDirection == 'ltr'}  class:rtl_cards={cardsDirection == 'rtl'}  on:input="{setCardsLenth}" spellcheck="false" resize={false} bind:value={cards} class="form-control" id="deck_cards" placeholder="Cards" rows="{cardsLength == 0 ? 10 : cardsLength}"></textarea>
            </div>
        </div>
    </form>
    <!-- <hr>
    {#if viewedDeck && deckId != 'new'}
        <div class="cards_list_wrapper">
            <CardsList deckId={deckId}/>
        </div>
    {/if} -->
    <input on:change="{loadDeckImage}" multiple="false" accept="image/*" class="deck_image_input_hid" type="file"
    id="deckImageInput">
    
</div>
{/if}


<style>
    .decks-container {
        border-right: 1px solid #f4f4f4;
        /* height: calc(100% - 36px); */
        /* height: 100vh; */
        height: 100%;
    }

    .deck_form{
        padding: 20px 40px;
    }

    .cards_list_wrapper{
        padding: 20px 40px;
    }

    .image_section {
        min-height: 350px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
    }
    .deck_image_input_hid{
        visibility: hidden;
        max-width: 0px;
        width: 0px;
        max-height: 0px;
        height: 0px;
    }

    .deck_image_input{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #eaeaea;
        color: #313131;
        cursor: pointer;
    }

    .deck_info{
        margin-top: 20px;
    }

    .picked_image{
        width: 100%;
        height: auto;
        object-fit: cover;
    }

    .image_wrapper{
        position: relative;
        width: 100%;
    }

    .override_image_btn{
        position: absolute;
        top: 5px;
        left: 5px;
    }

    .header {
        background-color: #efefef;
        display: block;
        width: 100%;
        min-height: 68px;
        border-bottom: 1px solid #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }

    .center{
        margin: 0 auto !important;
    }

    .loading{
        pointer-events: none;
        opacity: 0.5;
    }
    .deleteLoading{
        pointer-events: none;
        opacity: 0.5;
    }
    .my_btn_group{
        display: flex;
    }

    .ltr_cards{
        direction: ltr !important;
    }

    .rtl_cards{
        direction: rtl !important;
    }
</style>